import { useState } from 'react'
import { VStack, Button, Checkbox, FormControl, useToast, Link, HStack, Stack } from "@chakra-ui/react"
import { Link as ReactLink } from 'react-router-dom'
import { BsFileEarmarkCheck, BsPencilSquare } from "react-icons/bs";
import { patchUpdateFormRequest } from '../../classes/FormRequest';
import { useLoadingContext } from '../../context/loadingContext';
import { useUserContext } from '../../context/userContext';
import { toastErrDesc, toastVal } from '../../utils/toastUtils';
import { useHistory } from 'react-router';
import { SectionForm } from '../shared';

const SubmitConfirmPanel = ({ data }) => {

    const [check, setCheck] = useState(false)
    const toast = useToast()
    const { onModalClose, onModalOpen } = useLoadingContext()
    const { userData } = useUserContext()
    const history = useHistory()

    const submitHandle = async () => {
        if (check) {
            onModalOpen()
            // console.log(userData.token)
            await patchUpdateFormRequest(data.id, 'submit', userData.token)
                .then(res => {
                    onModalClose()
                    toast(toastVal({
                        title: "การบันทึกข้อมูลสำเร็จ",
                        description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                    }))

                    if (res.id) {
                        //redirect to home
                        history.push(`/form/${data.id}/final`)
                    }
                })
                .catch(error => {
                    onModalClose()
                    toast(toastVal({
                        title: "การบันทึกข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })
        } else {
            toast(toastVal({
                title: "ไม่สามารถดำเนินการได้",
                description: "กรุณากดยอมรับและปฏิบัติตามเงื่อนไข",
                status: "error",
            }))
        }
    }
    return (
        <VStack w="full">
            <SectionForm header="" divider={false} mt={6}>
                <FormControl isInvalid={!check}>
                    <Checkbox alignItems="baseline" isChecked={check} onChange={(e) => setCheck(e.target.checked)}>
                        ข้าพเจ้า ได้ทราบระเบียบสำนักงานศาลยุติธรรม ว่าด้วยการเข้าพักอาศัยในอาคารที่พักข้าราชการ
                        ศาลยุติธรรม ในเขตกรุงเทพมหานคร พ.ศ.2552 และที่แก้ไขเพิ่มเติม และหลักเกณฑ์การจัดลำดับการเข้าพักอาศัย
                        และยินยอมปฏิบัติตามโดยเคร่งครัดทุกประการ
                    </Checkbox>
                </FormControl>
            </SectionForm>
            <Stack w="full" direction={{ base: "column", md: "row" }} justify={{base:"",md:"center"}}>
                <Link as={ReactLink} to={`/form/${data.id}/step2`}>
                    <Button colorScheme="yellow" leftIcon={<BsPencilSquare />}>แก้ไขเอกสารแนบ</Button>
                </Link>
                <Button leftIcon={<BsFileEarmarkCheck />} isDisabled={!check} colorScheme="blue" onClick={submitHandle}>ยืนยันการยื่นแบบคำร้อง</Button>
            </Stack>
            <HStack w="full" justify="center">
                <Link to="/" as={ReactLink}>
                    <Button fontSize="md" variant="link" mt={4}>
                        กลับหน้าหลัก
                    </Button>
                </Link>
            </HStack>
        </VStack>
    )
}

export default SubmitConfirmPanel
